import { useLocation } from 'react-router-dom';
import { MessagesList } from './messagesList/MessagesList';
import { MessageDetail } from './messageDetail/MessageDetail';
import { messageDetailSubRouteRef } from '../routes';
import { useAsyncApiMessages } from '../hooks/useAsyncApiMessages';

export function AsyncApisMessagesApp() {
  const location = useLocation();
  const { messages, isLoading, error } = useAsyncApiMessages();

  // useParams doesn't work for MessageDetail because it is rendered conditionally inside this component,
  // not directly as a route-matched component. So we extract the parameter from the pathname manually
  // using the pattern from messageDetailSubRouteRef.path to keep it in sync with the route definition
  // The plugin is not rendered as a full, real plugin, thus built-in routing is not available because the subpages need to not inherit the parent plugin's/core's Headers and Navigation tabs, but the main page should inherit these
  const pathPattern = messageDetailSubRouteRef.path.replace(':messageName', '([^/?]+)');
  const match = location.pathname.match(new RegExp(pathPattern));
  const messageName = match?.[1];
  const isDetailPage = !!messageName;

  return (
    <>
      {!isDetailPage && <MessagesList messages={messages} isLoading={isLoading} error={error} />}
      {isDetailPage && messageName && <MessageDetail messageName={messageName} messages={messages} isLoading={isLoading} error={error} />}
    </>
  );
}
